import RaceCouponsView from './_race-coupons-view.js'

export default {
  name: 'RaceCoupons',
  values: {
    viewType: undefined,
    initiallyExpandedMeetings: undefined,
    raceCouponsView: {
      configSet: RaceCouponsView,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
